<template>
  <BaseEdit @edit-confirm-action="updateEntry" @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)" @clear-form-errors="clearFormErrors" ref="baseEdit"
    editTitle="Reemitir MDF-e" width="80%" :formErrors="formErrors" :loading="loading" :pageLoading="pageLoading"
    editSaveButtonLabel="Reemitir MDF-e" editIcon="mdi-file-restore" :readOnly="readOnly"
    :modelNameSingular="modelNameSingular">
    <template slot="editForm">
      <Form ref="form" :entry="editableEntry" :extraData="extraData" @formLoading="pageLoading = true"
        @formStopLoading="pageLoading = false" :printing="printing" id="printableELement" @formErrors="errorsFromForm"
        formType="edit" :readOnly="readOnly" :isEdit="isEdit" :modelNameSingular="modelNameSingular" />
      <!-- :formErrors="formErrors" -->
    </template>

  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
// import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      printing: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    // BasePrint: BasePrint,
  },
  methods: {
    loadServerEntry: function (id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_OUTBOUND_MDFE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id,

          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.mdfe;
          this.extraData = response.data;
          // console.log("NFe", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function (mdfe) {
      // console.log("Edit NFE ", nfe, nfe.validations, this.deepFilterEntryWithAllowedFieldsForMutation(nfe, nfe.validations))
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_MDFE_MUTATION,
          variables: {
            id: mdfe.id,
            input: this.deepFilterEntryWithAllowedFieldsForMutation(mdfe, mdfe.validations)
          }
        })
        .then(response => {
          // console.log(response.data);
          var errors = response.data.reIssueMdfe.errors
          if (errors.length) {
            this.formErrors = errors;
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.pageLoading = false;
            if (this.$router.currentRoute.name != "OutboundMdfe") {
              this.$router.push({ name: "OutboundMdfe" });
            }
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function () {
      if (this.$refs.form.isFormValid()) {
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function () {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function () {
      this.formErrors = [];
    },
    errorsFromForm: function (errors) {
      this.formErrors = this.formErrors.concat(errors);
    }
  }
};

const LOAD_OUTBOUND_MDFE_QUERY = gql`
  query ($id: ID!) {
    accountContext {
      mdfe(id: $id) {
        id
        series
        number
        stateIds
        loadStateId
        loadCityId
        unloadStateId
        unloadCityId
        loadType
        unitTotalWeightCode
        itemId
        nfeIds
        modal
        issuerType
        transporterType
        vehicleId
        carrierId
        mailingList
        status
        vCarga
        qCarga
        observations
        fiscoObservations
        taxPayerId
        validations
      }
      allModals
      allDrivers{
        id
        name
      }
      allTransportVehicles{
        id
        vehicleName
      }
      allTransportTrailers{
        id
        vehicleName
      }
      unitTotalWeightCodes
      loadTypes
      allCarriers{
        id
        name
      }
      allTransporterTypes
      allIssuerTypes
      allTaxPayers {
        id
        text
      }
      predominantProducts(mdfeId: $id){
        id
        name
      }
    }
    globalContext {
      allStates {
        id
        name
        shortName
        additionalInfo
        secondAdditionalInfo
      }
    }
  }
`;

const UPDATE_MDFE_MUTATION = gql`
  mutation($id: ID!, $input: IssueMdfeInputObject!) {
    reIssueMdfe(id: $id, input: $input) {
      mdfe {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
